import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

export interface SegmentedOption<T = string> {
	label: string;
	value: T;
	disabled?: boolean;
}

@Component({
	selector: 'kt-segmented-control',
	templateUrl: './segmented-control.component.html',
	styleUrls: ['./segmented-control.component.scss']
	// Removed ControlValueAccessor provider - we're using [value] binding directly, not ngModel
})
export class SegmentedControlComponent<T = string> implements OnChanges {
	@Input() options: SegmentedOption<T>[] = [];
	@Input() disabled: boolean = false;
	@Input() value: T | null = null;

	@Output() valueChange = new EventEmitter<T>();

	constructor() {}

	onButtonClick(option: SegmentedOption<T>): void {
		if (this.isOptionDisabled(option)) {
			return;
		}

		this.value = option.value;
		this.valueChange.emit(option.value);
	}

	isActive(optionValue: T): boolean {
		return this.value === optionValue;
	}

	// Removed ControlValueAccessor implementation - using [value] binding directly

	isOptionDisabled(option: SegmentedOption<T>): boolean {
		return this.disabled || !!option.disabled;
	}

	trackByOptionValue(index: number, option: SegmentedOption<T>): T {
		return option.value;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['value'] && !changes['value'].firstChange) {
			this.value = changes['value'].currentValue;
		}
	}
}

